// Manage saved scouts via API (database-backed)

import api from './axiosConfig';

export const scouts = {
  // Fetch all scouts for the authenticated user from API
  fetchUserScouts: async (signal) => {
    try {
      const response = await api.get('/api/scouts', { signal });
      return response.data.scouts || [];
    } catch (error) {
      // Ignore AbortError - request was cancelled intentionally
      if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
        return [];
      }
      console.error('Error fetching scouts:', error);
      // Return empty array on error to prevent breaking the UI
      return [];
    }
  },

  // Get all scouts for a user (deprecated - use fetchUserScouts instead)
  // Kept for backward compatibility
  getUserScouts: (userId) => {
    console.warn('getUserScouts is deprecated. Use fetchUserScouts() instead.');
    const allScouts = JSON.parse(localStorage.getItem('rentalScoutScouts') || '[]');
    return allScouts.filter(s => s.userId === userId);
  },

  // Delete a scout via API
  delete: async (scoutId) => {
    try {
      await api.delete(`/api/scouts/${scoutId}`);
      return true;
    } catch (error) {
      console.error('Error deleting scout:', error);
      throw error;
    }
  },

  // Get all scouts (deprecated - kept for backward compatibility)
  getAll: () => {
    console.warn('getAll is deprecated. Use fetchUserScouts() instead.');
    return JSON.parse(localStorage.getItem('rentalScoutScouts') || '[]');
  }
};

